/**
 * KPI card: label + delta pill + big number + hint + sparkline.
 *
 * `format` lets each card present its raw value differently (seconds vs
 * percentage vs count). `invert` is forwarded to Sparkline + Delta so the
 * "good direction" colour is correct for inverse metrics like response
 * time.
 *
 * Loading state shows a skeleton in place of the number (deltas/sparklines
 * are hidden during loading to avoid flashing wrong colours).
 */
import { Card } from "../../../../UI";
import Delta from "../Delta/Delta";
import Sparkline from "../Sparkline/Sparkline";
import { KpiCardStyles, KpiSkeleton } from "./kpiCard.styles";

const KpiCard = ({
  label,
  value,
  prev,
  format = v => v,
  hint,
  suffix,
  spark = [],
  invert = false,
  loading = false,
  showCompare = true
}) => (
  <KpiCardStyles>
    <Card className="kpi-card">
      <div className="kpi-card__head">
        <span className="kpi-card__label">{label}</span>
        {showCompare && !loading && (
          <Delta curr={value} prev={prev} invert={invert} />
        )}
      </div>
      {loading ? (
        <KpiSkeleton />
      ) : (
        <div className="kpi-card__value">
          {format(value)}
          {suffix && <span className="kpi-card__suffix">{suffix}</span>}
        </div>
      )}
      <div className="kpi-card__foot">
        <span className="kpi-card__hint">{hint}</span>
        {!loading && <Sparkline values={spark} invert={invert} />}
      </div>
    </Card>
  </KpiCardStyles>
);

export default KpiCard;
